<template>
    <v-server-table :url="url"  :columns="columns" :options="options" class="trigger" ref="table">
        <template slot="location_name" slot-scope="props">
            {{ props.row.name }}
        </template>
        <template slot="address" slot-scope="props">
            {{ props.row.addresses[0].street + ' ' +  props.row.addresses[0].house_number }}
        </template>
        <template slot="zipcode" slot-scope="props">
            {{ props.row.addresses[0].zipcode }}
        </template>
        <template slot="city" slot-scope="props">
            {{ props.row.addresses[0].city }}
        </template>
        <template slot="country" slot-scope="props">
            {{ props.row.addresses[0].country['name'] }}
        </template>
    </v-server-table>
</template>

<script>
    import Actions from '~/components/tables/location/actions'
    import { TableMixin } from '~/mixins'
    import { event }  from '~/events'
    import { mapGetters } from 'vuex'
    import store from '~/store'

    export default {
        name: 'index',
        props: {
            url: {
                type: String,
                required: true
            },
        },
        mixins: [ TableMixin ],
        mounted() {
            event.init();
            event.on('reloadTable', () => {
                vue.$emit('reloadTable');
            })
        },
        data () {
            return {
                columns: ['location_name', 'address', 'zipcode', 'city', 'country', 'actions'],
                // filterable: ['location_name', 'address', 'zipcode', 'city', 'country'],
                templates: {
                    actions: Actions,
                },
                options: {
                    headings: {
                        location_name: this.uLang('app.name'),
                        address: this.uLang('app.address'),
                        zipcode: this.uLang('app.zipcode'),
                        city: this.uLang('app.city'),
                        country: this.uLang('app.country'),
                        actions: this.uLang('app.actions'),
                    },
                    texts: {
                        count: this.uLang('app.table_record'),
                        filter: this.uLang('app.filter_results'),
                        filterPlaceholder: this.uLang('app.search_query'),
                        limit: this.uLang('app.results'),
                        noResults: this.uLang('app.no_matching_records'),
                        page: this.uLang('app.page'),
                        filterBy: this.uLang('app.filter_by')
                    }
                }
            }
        },
        created: function () {
            //set filter placeholder column name lowercase
            setTimeout(function () {
                [].forEach.call(
                    document.querySelectorAll('.VueTables__filters-row th input'),
                    function(el){
                        let placeholder = el.placeholder.toLowerCase();
                        el.placeholder = placeholder.charAt(0).toUpperCase() + placeholder.slice(1);
                    }
                );
            }, 15);
        },
    }
</script>

<style lang="css" scoped>
</style>